import(/* webpackMode: "eager" */ "/app/app/components/banner/DomruBanner.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/components/banner/YandexRtbAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/client/MoonAnimationClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/client/NightSkyParticlesClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/client/SunAnimationClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/forecast/ForecastTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/forecast/HistoricalWeatherChartLazy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/HealthWeather.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/HistoricalWeather.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/home/AdminTrafficStatsModal.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/WeatherAssistantClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/WeatherHighlights.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/WindMapLazy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
